import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Currency } from '../models/enums/currency';
import { SlingConfigService } from './sling-config.service';

@Injectable({
  providedIn: 'root'
})
export class CurrencyService {
  
  private currentCurrencySubject = new BehaviorSubject<Currency>(Currency.BRL);

  constructor(private slingConfigService: SlingConfigService) {
    this.loadCurrentCurrency();
  }

  private loadCurrentCurrency(): void {
    this.slingConfigService.getSlingConfig().subscribe(
      (configs) => {
        if (configs && configs.length > 0) {
          const currency = configs[0].currency || Currency.BRL;
          this.setCurrentCurrency(currency);
        } else {
          this.setCurrentCurrency(Currency.BRL);
        }
      },
      (error) => {
        console.warn('Erro ao carregar configuração de moeda, usando BRL como padrão', error);
        this.setCurrentCurrency(Currency.BRL);
      }
    );
  }

  setCurrentCurrency(currency: Currency): void {
    this.currentCurrencySubject.next(currency);
  }

  getCurrentCurrency(): Currency {
    return this.currentCurrencySubject.value;
  }
} 